<template>
    <div class="w-full">
        <h4 class="mb-3">Packages</h4>

        <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addPackagePrompt = true">Add</vs-button>

        <vx-card id="packagesDiv"  class="vs-con-loading__container">

            <vs-table ref="table" @selected="openPackage" :data="tableData" class="mt-3" pagination search :maxItems="itemsPerPage">
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="name">Name</vs-th>
                    <vs-th sort-key="days">Days</vs-th>
                    <vs-th sort-key="credits">Credits</vs-th>
                    <vs-th sort-key="trial_enabled">Trial enabled</vs-th>
                    <vs-th sort-key="trial_days">Trial days</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].name">
                            {{ data[index].name }}
                        </vs-td>

                        <vs-td :data="data[index].days">
                            {{ data[index].days }}
                        </vs-td>

                        <vs-td :data="data[index].credits">
                            {{ data[index].credits }}
                        </vs-td>

                        <vs-td :data="data[index].trial_enabled">
                            <vs-chip v-if="data[index].trial_enabled" color="success">Yes</vs-chip>
                            <vs-chip v-else color="danger">No</vs-chip>
                        </vs-td>

                        <vs-td :data="data[index].trial_days">
                            {{ data[index].trial_days }}
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>

        <vs-popup title="Add package" :active.sync="addPackagePrompt">
            <div id="addPackageDiv" class="vs-con-loading__container" >
                <p class="mt-6">Name</p>
                <vs-input v-model="addObject['name']" class="w-full"></vs-input>
                <p class="mt-6">Days</p>
                <vs-input v-model="addObject['days']" class="w-full"></vs-input>
                <p class="mt-6">Credits</p>
                <vs-input v-model="addObject['credits']" class="w-full"></vs-input>

                <div class="vx-row mt-6">
                    <div class="vx-col w-1/3 mt-1">
                        <vs-checkbox class="mt-6" v-model="addObject['trial_enabled']">Trial enabled</vs-checkbox>
                    </div>
                    <div class="vx-col w-2/3">
                        <p>Trial days</p>
                        <vs-input :disabled="!addObject['trial_enabled']" v-model="addObject['trial_days']" class="w-full"></vs-input>
                    </div>
                </div>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addPackage">Add</vs-button>
            </div>
        </vs-popup>

    </div>
</template>
<script>

    export default {

        data() {
            return {

                itemsPerPage: 20,
                isMounted: false,

                packages: [],

                addPackagePrompt: false,

                addObject: {
                    days: 30,
                    credits: 0,
                    trial_enabled: false,
                    trial_days: 7
                }

            }
        },
        methods: {

            loadData() {
                this.$vs.loading({
                    container: '#packagesDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/package/')
                loadPromise.then(function(response) {
                    thisIns.packages = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#packagesDiv > .con-vs-loading')
                })
            },
            addPackage() {
                this.$vs.loading({
                    container: '#addPackageDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const addPromise = this.$http.post('/api/management/v1/package/', {
                    name: this.addObject.name,
                    days: Number(this.addObject.days),
                    credits: Number(this.addObject.credits),
                    trial_enabled: this.addObject.trial_enabled,
                    trial_days: Number(this.addObject.trial_days)
                })

                addPromise.then(function(response) {
                    thisIns.addPackagePrompt = false
                    thisIns.$printSuccess('Package added')
                    thisIns.$nextTick(() => {
                        thisIns.$router.push('/package/' + response.data.id)
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#addPackageDiv > .con-vs-loading')
                })
            },
            openPackage(tr) {
                this.$router.push('/package/' + tr.id)
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableItems() {
                if (this.isMounted) {
                    return this.$refs.table.queriedResults.length
                }
                return 0
            },
            tableData() {
                return this.packages
            }
        },
        mounted() {
            this.isMounted = true
            this.loadData()
        }

    }

</script>
